import React from 'react';

export const money = (v, dec = 0) => '$' + Number(v || 0).toLocaleString('es-AR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
export const moneyK = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 1e6) return '$' + (n / 1e6).toLocaleString('es-AR', { maximumFractionDigits: 1 }) + ' M';
  if (Math.abs(n) >= 1e3) return '$' + Math.round(n / 1e3).toLocaleString('es-AR') + ' mil';
  return money(n);
};
export const fecha = (d) => {
  if (!d) return '—';
  const s = String(d).slice(0, 10).split('-');
  return `${s[2]}/${s[1]}/${s[0]}`;
};
export const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
export const mesLabel = (m) => { const [y, mm] = String(m).split('-'); return `${MESES[Number(mm) - 1]} ${String(y).slice(2)}`; };
export const hoy = () => new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);

export const ESTADO_COBRO = {
  pendiente: { label: 'Pendiente', color: '#f59e0b', bg: 'rgba(245,158,11,0.15)' },
  vencido: { label: 'Vencido', color: '#ef4444', bg: 'rgba(239,68,68,0.15)' },
  informado: { label: 'Informado', color: '#0ea5e9', bg: 'rgba(14,165,233,0.15)' },
  pagado: { label: 'Pagado', color: '#22c55e', bg: 'rgba(34,197,94,0.15)' },
  anulado: { label: 'Anulado', color: '#64748b', bg: 'rgba(100,116,139,0.15)' },
};
export const ESTADO_RENOVACION = {
  por_preparar: { label: 'Por preparar', color: '#f59e0b' },
  preparada: { label: 'Preparada', color: '#0ea5e9' },
  enviada: { label: 'Enviada', color: '#a855f7' },
  renovada: { label: 'Renovó', color: '#22c55e' },
  no_renovo: { label: 'No renovó', color: '#ef4444' },
  en_gracia: { label: 'Período de gracia', color: '#f97316' },
};

export const Badge = ({ label, color, bg }) => (
  <span className="badge" style={{ background: bg || 'transparent', color: color || 'var(--text-secondary)', border: bg ? 'none' : '1px solid var(--border)', fontSize: 11 }}>{label}</span>
);

// Un dato importante: acento de color, ícono opcional y el contexto abajo
export const Kpi = ({ label, value, sub, color, onClick, icono: Icono }) => {
  const c = color && color !== 'var(--text-primary)' ? color : 'var(--accent)';
  const suave = c.startsWith('#') ? c + '22' : 'var(--accent-glow)';
  return (
    <div className={'card card-dato' + (onClick ? ' clickeable' : '')}
      style={{ '--dato-color': c, '--dato-suave': suave }} onClick={onClick}>
      {Icono && <div className="dato-icono"><Icono size={18} /></div>}
      <div style={{ minWidth: 0 }}>
        <div className="dato-label">{label}</div>
        <div className="dato-valor" style={{ color: color || 'var(--text-primary)' }}>{value}</div>
        {sub && <div className="dato-sub">{sub}</div>}
      </div>
    </div>
  );
};

export const Title = ({ children, right, seccion = 'Agencia' }) => (
  <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 12, marginBottom: 22, flexWrap: 'wrap' }}>
    <div>
      <div className="encabezado-eyebrow">{seccion}</div>
      <h1 className="encabezado-titulo">{children}</h1>
      <div className="encabezado-linea" />
    </div>
    {right}
  </div>
);

export const Empty = ({ children }) => <p style={{ color: 'var(--text-muted)', fontSize: 13, padding: '12px 0' }}>{children}</p>;
